module.exports = __webpack_public_path__ + "static/media/Orto botanico - GR Green_Ind.Blue.b11b5589.jpg";